/* TWRD (Black & White): swipe dots for the touch image track on the collection card.
   The track itself is CSS only. This file only mirrors the scroll position
   into the two dots, and only on touch devices. */
(function () {
  'use strict';

  var TOUCH_QUERY = '(hover: none)';

  function isTouch() {
    return window.matchMedia && window.matchMedia(TOUCH_QUERY).matches;
  }

  function activeIndex(track) {
    var width = track.clientWidth;
    if (!width) return 0;
    return Math.round(track.scrollLeft / width);
  }

  function paint(card) {
    var track = card.track;
    var index = activeIndex(track);
    if (index === card.index) return;
    card.index = index;
    for (var i = 0; i < card.dots.length; i += 1) {
      card.dots[i].classList.toggle('is-active', i === index);
    }
  }

  function bind(ratioContent) {
    if (ratioContent.dataset.twrdSwipeBound === 'true') return;
    var track = ratioContent.querySelector('.product-card__media--hover-image');
    var dotsWrap = ratioContent.querySelector('[data-twrd-dots]');
    if (!track || !dotsWrap) return;
    var dots = dotsWrap.querySelectorAll('[data-twrd-dot]');
    if (dots.length < 2) return;

    ratioContent.dataset.twrdSwipeBound = 'true';
    var card = { track: track, dots: dots, index: 0, frame: 0 };

    track.addEventListener(
      'scroll',
      function () {
        if (card.frame) return;
        card.frame = window.requestAnimationFrame(function () {
          card.frame = 0;
          paint(card);
        });
      },
      { passive: true }
    );

    paint(card);
  }

  function scan(root) {
    if (!isTouch()) return;
    var scope = root || document;
    var nodes = scope.querySelectorAll('.twrd-cards .o-ratio__content');
    for (var i = 0; i < nodes.length; i += 1) bind(nodes[i]);
  }

  function start() {
    scan(document);
    // The theme re-renders the grid over AJAX. The loaded event does not
    // bubble, so it is bound on each search element directly.
    var searches = document.querySelectorAll('dynamic-product-search');
    for (var i = 0; i < searches.length; i += 1) {
      searches[i].addEventListener('on:dynamic-product-search:loaded', function (event) {
        scan(event.currentTarget);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
